const holder = {
  closeDateRangeSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDateRangeSelector)
    }
  }
};

export default {
  'DatePicker.Icon': ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter
    holder.containerRef = containerRef
    internalStateSetter({ isOpen: !isOpen });
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDateRangeSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDateRangeSelector);
    }
  },
  'DatePicker.CalendarOuterWrapper.CalendarWrapper.Calendar': ({ selectedDate }, outlet, internalStateSetter) => {
    internalStateSetter({ isOpen: false })
    outlet({ selectedDate })
  }
}